module.exports = __webpack_public_path__ + "files/primary.025c02f4213c30e1912e2ee5432799f1.png";